export enum PriceInterval {
  MONTH = 'month',
  YEAR = 'year',
}

export enum PriceProductKey {
  INDIVIDUAL = 'as_an_individual',
  COMPANY = 'as_a_company',
  ENTERPRISE = 'as_enterprise',
}

export const priceTierOrder = [
  PriceProductKey.INDIVIDUAL,
  PriceProductKey.COMPANY,
  PriceProductKey.ENTERPRISE,
];
